import React, {Component} from 'react';
import { Row, Col } from 'antd';

class newPost extends Component {
  
  render() {
    return (
      <Row gutter={16}>
        <Col gutter={16} sm={24}>
             New Trade
        </Col>
      </Row>
    )
  }
}

export default newPost;





// WEBPACK FOOTER //
// ./src/components/Admin/newTrade.js